import { v4 as uuidv4 } from 'uuid';
export class Questionaire {
  constructor() {
    this.id = uuidv4();
  }

  id: string;
  docId: string;
  type: string;
  questions: Question[];

}

export class Question {
  question: string;
  isMultiSelect: boolean;
  showInterests: boolean;
  type:string;
  valueType:string;
  start:number;
  end:number;
  responses: Response[];
  values:any[];
}

export class Response {
  num: number;
  response: string;
}
